import { render, staticRenderFns } from "./faxian.vue?vue&type=template&id=414dcd99&scoped=true"
import script from "./faxian.vue?vue&type=script&lang=js"
export * from "./faxian.vue?vue&type=script&lang=js"
import style0 from "./faxian.vue?vue&type=style&index=0&id=414dcd99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414dcd99",
  null
  
)

export default component.exports